<div class="container">
    <div class="row mt-4">
        <div class="col-lg-6">
            <h3 class="fw-semibold mb-2 display-6">What our customers say</h3>
            <p class="text-muted">Testimonials from e-commerce platform that purchased Bewell products</p>
        </div>
        <div class="col-lg-6">
            <span class="float-end">
                <button type="button" (click)="prev()" [disabled]="isPrevDisabled()" class="btn carousel-ctrl">
                    <img src="assets/icons/previous.svg">
                </button>
                <button type="button" (click)="next()" [disabled]="isNextDisabled()" class="btn carousel-ctrl">
                    <img src="assets/icons/next.svg">
                </button>
            </span>
        </div>
        <div class="col-lg-12 p-0 m-0 inter">
            <div class="carousel-wrapper">
                <div class="row p-0 m-0">
                    <div class="carousel-viewport">
                        <div class="carousel-track" [style.transform]="trackTransform()">
                            @for (obj of testimonials; track obj.id) {
                                <div class="carousel-card">
                                    <div class="carousel-content">
                                        <div class="ct rounded-3 rounded p-4 fs-6 text-muted mt-4">
                                            <div class="container p-0">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="fs-7 mb-4">
                                                            <img src="assets/icons/verified.svg" class="customer-purchased">
                                                            <span class="fw-medium text-dark inter">Verified Purchased</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="com lh-base inter fs-6">
                                                <q>{{obj?.comment}}</q>
                                            </div>
                                            <div class="container p-0">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="text-dark fs-7 inter">By: {{obj?.customer}}</div>
                                                        <img [src]="obj?.img" [alt]="obj?.alt" class="cp">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>